import { useQuery } from 'react-query';

import { useAuth } from 'modules/authentication/presentation/contexts';
import { makeVerifyNpsSessionFeedbackUseCase } from 'shared/domain/useCases';
import { sharedQueries } from 'shared/presentation/constants';

export default function useVerifyNpsSessionFeedback() {
  const { guestId, loggedAsGuest } = useAuth();

  const query = useQuery(
    sharedQueries.verifyNpsSessionFeedback(guestId, loggedAsGuest),
    () => makeVerifyNpsSessionFeedbackUseCase().execute({ id: guestId! }),
    {
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      enabled: !!guestId && !loggedAsGuest,
    },
  );

  return {
    session: query.data,
    loading: query.isLoading,
  };
}
